'use client';
import { isString } from '@s7/utils';

const getColorStyles = (theme, color)=>{
    if (isString(color)) {
        return {
            color: theme.fn.primaryShade(theme.fn.themeColor(color))
        };
    }
    return {
        backgroundImage: theme.fn.gradient(color),
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent'
    };
};

export { getColorStyles };
//# sourceMappingURL=getColorStyles.js.map
